module.exports = __webpack_public_path__ + "img/close-circle.2c183995.svg";